export function calcPagesQuantity(size: number, total: number) {
  return Math.ceil(total / size);
}
